module.exports = __webpack_public_path__ + "static/media/download_phone.03e0313a.png";